module.exports = __webpack_public_path__ + "static/img/nav-3.7a48dd1d.svg";